export default {
    TABS: state => state.tabs,

    ACTIVE_TAB: state => state.activeTab,
    USE_TABS_NAVIGATION: state => state.useTabsNavigation
}